import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularArrowDown: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_arrow-down"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="arrow-down icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M5.81769 5.81806C6.01295 5.6228 6.32953 5.62279 6.52479 5.81806L11.3281 10.6214V6.87872C11.3281 6.60257 11.552 6.37872 11.8281 6.37872C12.1042 6.37872 12.3281 6.60257 12.3281 6.87872L12.3281 11.8285C12.3281 12.1046 12.1042 12.3285 11.8281 12.3285L6.87835 12.3285C6.6022 12.3285 6.37835 12.1046 6.37835 11.8285C6.37835 11.5523 6.6022 11.3285 6.87835 11.3285L10.621 11.3285L5.81769 6.52516C5.62242 6.3299 5.62242 6.01332 5.81769 5.81806Z" />
      </svg>
    </span>
  );
};

export { RegularArrowDown };
